export default __webpack_public_path__ + "static/media/forSchool.a3b45b8e.png";